import React, { useEffect, useRef } from 'react';
export function PainSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1
    });
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="py-20 px-4" style={{
    background: 'linear-gradient(135deg, #2C1810 0%, #3D2015 50%, #2C1810 100%)'
  }} data-id="element-130">
      <div className="max-w-5xl mx-auto" data-id="element-131">
        {/* Headline */}
        <div className="text-center mb-14" data-id="element-132">
          <h2 className="reveal font-playfair text-4xl md:text-5xl font-bold mb-4" style={{
          color: 'var(--color-cream)'
        }} data-id="element-133">
            Te reconoces en esto...
          </h2>
          <div className="reveal reveal-delay-1 w-16 h-1 mx-auto rounded-full" style={{
          background: 'var(--color-gold)'
        }} data-id="element-134" />
        </div>

        {/* Pain cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14" data-id="element-135">
          {/* Card 1 */}
          <div className="reveal reveal-delay-1 rounded-2xl p-6 border" style={{
          background: 'rgba(253, 248, 240, 0.05)',
          borderColor: 'rgba(212, 168, 83, 0.2)'
        }} data-id="element-136">
            <div className="text-4xl mb-4" data-id="element-137">🪞</div>
            <h3 className="font-playfair text-lg font-bold mb-3" style={{
            color: 'var(--color-gold)'
          }} data-id="element-138">
              El espejo no miente
            </h3>
            <p className="font-lato text-sm leading-relaxed" style={{
            color: 'rgba(253, 248, 240, 0.8)'
          }} data-id="element-139">
              Las arrugas de entrecejo que ayer eran sutiles, hoy son surcos
              profundos. Cada mañana, una nueva línea. La confianza se va con
              cada una.
            </p>
          </div>

          {/* Card 2 */}
          <div className="reveal reveal-delay-2 rounded-2xl p-6 border" style={{
          background: 'rgba(253, 248, 240, 0.05)',
          borderColor: 'rgba(212, 168, 83, 0.2)'
        }} data-id="element-140">
            <div className="text-4xl mb-4" data-id="element-141">☀️</div>
            <h3 className="font-playfair text-lg font-bold mb-3" style={{
            color: 'var(--color-gold)'
          }} data-id="element-142">
              El triple golpe español
            </h3>
            <p className="font-lato text-sm leading-relaxed" style={{
            color: 'rgba(253, 248, 240, 0.8)'
          }} data-id="element-143">
              Estrés laboral + sol mediterráneo + noches malas. En España, la
              combinación UV + contaminación envejece la piel el doble de
              rápido.
            </p>
          </div>

          {/* Card 3 */}
          <div className="reveal reveal-delay-3 rounded-2xl p-6 border" style={{
          background: 'rgba(253, 248, 240, 0.05)',
          borderColor: 'rgba(212, 168, 83, 0.2)'
        }} data-id="element-144">
            <div className="text-4xl mb-4" data-id="element-145">💻</div>
            <h3 className="font-playfair text-lg font-bold mb-3" style={{
            color: 'var(--color-gold)'
          }} data-id="element-146">
              Mañana videollamada clave
            </h3>
            <p className="font-lato text-sm leading-relaxed" style={{
            color: 'rgba(253, 248, 240, 0.8)'
          }} data-id="element-147">
              Te ves más cansada que anoche. La cámara no perdona. Necesitas una
              solución real, no otro consejo de influencer de 25 años.
            </p>
          </div>
        </div>

        {/* Stats row */}
        <div className="reveal grid grid-cols-1 md:grid-cols-3 gap-4 mb-12 rounded-2xl p-6" style={{
        background: 'rgba(212, 168, 83, 0.08)',
        border: '1px solid rgba(212, 168, 83, 0.25)'
      }} data-id="element-148">
          <div className="text-center py-4" data-id="element-149">
            <p className="font-playfair text-4xl font-black mb-2" style={{
            color: 'var(--color-gold)'
          }} data-id="element-150">
              30%
            </p>
            <p className="font-lato text-sm" style={{
            color: 'rgba(253, 248, 240, 0.75)'
          }} data-id="element-151">
              colágeno perdido post-40 cada año
            </p>
          </div>
          <div className="text-center py-4 border-y md:border-y-0 md:border-x" style={{
          borderColor: 'rgba(212, 168, 83, 0.2)'
        }} data-id="element-152">
            <p className="font-playfair text-4xl font-black mb-2" style={{
            color: 'var(--color-gold)'
          }} data-id="element-153">
              2×
            </p>
            <p className="font-lato text-sm" style={{
            color: 'rgba(253, 248, 240, 0.75)'
          }} data-id="element-154">
              UV España acelera el envejecimiento
            </p>
          </div>
          <div className="text-center py-4" data-id="element-155">
            <p className="font-playfair text-4xl font-black mb-2" style={{
            color: 'var(--color-gold)'
          }} data-id="element-156">
              T+S
            </p>
            <p className="font-lato text-sm" style={{
            color: 'rgba(253, 248, 240, 0.75)'
          }} data-id="element-157">
              Piel mixta: zona T grasa + mejillas secas por A/C
            </p>
          </div>
        </div>

        {/* Emotional closer */}
        <div className="reveal text-center" data-id="element-158">
          <p className="font-playfair text-2xl md:text-3xl font-bold italic" style={{
          color: 'var(--color-cream)'
        }} data-id="element-159">
            "No es vanidad.{' '}
            <span style={{
            color: 'var(--color-gold)'
          }} data-id="element-160">
              Es real.
            </span>
            "
          </p>
        </div>
      </div>
    </section>;
}